import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';

const ReusableTabs = ({ 
  tabs, 
  defaultTab = 0, 
  activeTab: controlledTab,
  onTabChange, 
  containerStyles = {}, 
  panelStyles = {}, 
}) => {
  const [internalTab, setInternalTab] = useState(defaultTab);
  const activeTab = controlledTab !== undefined ? controlledTab : internalTab;

  const handleTabChange = (event, newValue) => {
    if (controlledTab === undefined) {
      setInternalTab(newValue); // uncontrolled mode
    }
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  const switchToTab = (tabIndex) => {
    if (tabIndex >= 0 && tabIndex < tabs.length) {
      if (controlledTab === undefined) {
        setInternalTab(tabIndex);
      }
      if (onTabChange) {
        onTabChange(tabIndex);
      }
    }
  };

  return (
    <div style={containerStyles}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={activeTab} onChange={handleTabChange}>
          {tabs.map((tab, index) => (
            <Tab key={index} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      <Box sx={panelStyles} className="bg-gray-100 rounded shadow">
        {tabs.map((tab, index) =>
          activeTab === index ? (
            <div key={index}>
              {React.cloneElement(tab.component, { switchToTab })}
            </div>
          ) : null
        )}
      </Box>
    </div>
  );
};

export default ReusableTabs;